/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:51
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-10 15:06:29
 */
import SSelect from './SSelect/index'
import SSelectOption from './SSelectOption/index'
import SModal from './SModal/index'
import SInput from './SInput/index'
import SButton from './SButton/index'
import SHelp from './SHelp/index'

const modules = [
  SSelect,
  SSelectOption,
  SModal,
  SInput,
  SButton,
  SHelp
]

export default {
  install: (Vue) => {
    modules.forEach(module => {
      Vue.component(module.name, module)
    })
  }
}
